import { css } from 'emotion';

export const styles = {
  icon: css({
    marginRight: '10px',
  }),
};
